import(/* webpackMode: "eager", webpackExports: ["Container"] */ "/srv/project/front-org/node_modules/@mantine/core/esm/components/Container/Container.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/srv/project/front-org/node_modules/@mantine/core/esm/core/Box/Box.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Body"] */ "/srv/project/front-org/src/shared/ui/body/Body.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumb"] */ "/srv/project/front-org/src/shared/ui/breadcrumb/Breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalendarLink"] */ "/srv/project/front-org/src/shared/ui/calendar-link/CalendarLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomLink"] */ "/srv/project/front-org/src/shared/ui/custom-link/CustomLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DetailsLink"] */ "/srv/project/front-org/src/shared/ui/details-link/DetailsLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Empty"] */ "/srv/project/front-org/src/shared/ui/empty/Empty.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkBox"] */ "/srv/project/front-org/src/shared/ui/link-box/LinkBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Masonry"] */ "/srv/project/front-org/src/shared/ui/masonry/Masonry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotFound"] */ "/srv/project/front-org/src/shared/ui/not-found/NotFound.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollAnimation"] */ "/srv/project/front-org/src/shared/ui/scroll-animation/ScrollAnimation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SliderArrow"] */ "/srv/project/front-org/src/shared/ui/slider-arrow/SliderArrow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialMediaIcon"] */ "/srv/project/front-org/src/shared/ui/social-media-icon/SocialMediaIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SuspenseLoader"] */ "/srv/project/front-org/src/shared/ui/suspense-loader/SuspenseLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Title"] */ "/srv/project/front-org/src/shared/ui/title/Title.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Views"] */ "/srv/project/front-org/src/shared/ui/views/Views.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ZoomImage"] */ "/srv/project/front-org/src/shared/ui/zoom-image/ZoomImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accessibility"] */ "/srv/project/front-org/src/widgets/accessibility/Accessibility.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackToTop"] */ "/srv/project/front-org/src/widgets/back-to-top/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Captcha"] */ "/srv/project/front-org/src/widgets/captcha/Captcha.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Content"] */ "/srv/project/front-org/src/widgets/content/Content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Employee"] */ "/srv/project/front-org/src/widgets/employee/Employee.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfoContent"] */ "/srv/project/front-org/src/widgets/info-content/InfoContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher"] */ "/srv/project/front-org/src/widgets/language-switcher/LanguageSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Messenger"] */ "/srv/project/front-org/src/widgets/messenger/Messenger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsCard"] */ "/srv/project/front-org/src/widgets/news-card/NewsCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnlineConsultant"] */ "/srv/project/front-org/src/widgets/online-consultant/OnlineConsultant.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaginationWidget"] */ "/srv/project/front-org/src/widgets/pagination/Pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Poll"] */ "/srv/project/front-org/src/widgets/poll/Poll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProgressBar"] */ "/srv/project/front-org/src/widgets/progress-bar/ProgressBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PushNotification"] */ "/srv/project/front-org/src/widgets/push-notification/PushNotification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RightMenu"] */ "/srv/project/front-org/src/widgets/right-menu/RightMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Share"] */ "/srv/project/front-org/src/widgets/share/Share.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SkipToMainContent"] */ "/srv/project/front-org/src/widgets/skip-to-main-content/SkipToMainContent.tsx");
